import { showKomboConnect } from '@kombo-api/connect'

import buildUrl from 'modules/core/lib/buildUrl'
import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'

import {
  ACTIVATE_PATH,
  LOGIN_PATH,
  RELINK_PATH,
  STATUS_PATH,
} from 'modules/payroll_integrations_datev_api/lib/constants'

export enum Status {
  NotAvailable = 'not_available',
  NotAuthenticated = 'not_authenticated',
  AuthenticationExpired = 'authentication_expired',
  Authenticated = 'authenticated',
}

interface StatusResponse {
  status: Status
}

interface Data {
  companyId: string | undefined
  bookkeeperView: boolean
}

class AuthService {
  private async activateIntegration(token: string, companyId?: string) {
    await ApiClient().post(ACTIVATE_PATH, {
      method: 'POST',
      token: token,
      company_id: companyId,
    })
  }

  private async getStatusResponse(data: Data): Promise<StatusResponse> {
    const response = await ApiClient().get(STATUS_PATH, {
      bookkeeper_view: data.bookkeeperView,
      company_id: data.companyId,
    })

    return response
  }

  async getStatus(data: Data): Promise<Status> {
    const response = await this.getStatusResponse(data)

    return response.status
  }

  async connect(authStatus: Status, companyId?: string) {
    const loginUrl = buildUrl(`${LOGIN_PATH}?company_id=${companyId}`)
    const relinkUrl = buildUrl(`${RELINK_PATH}?company_id=${companyId}`)

    const path = authStatus == Status.AuthenticationExpired ? relinkUrl : loginUrl

    const activationToken = await showKomboConnect(path)

    await this.activateIntegration(activationToken, companyId)
  }
}

export default new AuthService()
